import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CalendarCheck, X } from "lucide-react";

const FloatingCTA = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Hide on the booking page itself
  if (location.pathname === "/book" || dismissed) return null;

  return (
    <div
      className={`fixed bottom-5 right-5 z-40 transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-6 opacity-0"
      }`}
    >
      <div className="group relative">
        <div className="absolute -inset-1 rounded-full bg-gradient-to-r from-primary to-secondary opacity-60 blur-md transition-opacity duration-500 group-hover:opacity-100" />
        <Link
          to="/book"
          className="relative inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-primary to-secondary px-5 py-3 text-sm font-semibold text-white shadow-[0_10px_40px_-10px_hsl(207_68%_50%/0.7)] transition-transform hover:scale-[1.03]"
        >
          <CalendarCheck className="h-4 w-4" />
          <span className="hidden sm:inline">Book a Free Strategy Call</span>
          <span className="sm:hidden">Book Free Call</span>
        </Link>
        <button
          aria-label="Dismiss"
          onClick={() => setDismissed(true)}
          className="absolute -right-2 -top-2 inline-flex h-6 w-6 items-center justify-center rounded-full border border-white/20 bg-background/80 text-muted-foreground shadow backdrop-blur transition-colors hover:text-foreground"
        >
          <X className="h-3 w-3" />
        </button>
      </div>
    </div>
  );
};

export default FloatingCTA;
